class MenuToggle {
  constructor(element, menu) {
    this.element = element
    this.menu    = menu

    this.element.addEventListener("click", (event) => {
      event.preventDefault()
      this._toggle()
    })
  }

  close() {
    this.element.innerHTML = "More &#8942;"
  }

  open() {
    this.element.innerHTML = "&times; Close"
  }

  _toggle() {
    if (this.menu.shown) {
      this.close()
      this.menu.hide()
    }
    else {
      this.open()
      this.menu.show()
    }
  }
}

class Menu {
  constructor(element) {
    this.element = element
    this.shown = !element.classList.contains("dn") && 
                  element.classList.contains("db")
  }

  show() {
    if (this.shown) {
      return
    }
    this.element.classList.add("db")
    this.element.classList.remove("dn")
    this.shown = true
  }
  hide() {
    if (!this.shown) {
      return
    }
    this.element.classList.remove("db")
    this.element.classList.add("dn")
    this.shown = false
  }
}
export default class MobileMenu {
  constructor(document) {
    this.menu = new Menu(document.querySelector("[data-menu]"))
    this.menuToggle = new MenuToggle(document.querySelector("[data-menu-toggle]"), this.menu)
  }
  start() {
  }
}
